import { createSelector } from "reselect";

const carriersState = (state) => state.carriers;

export const selectAllCarriers = createSelector(carriersState, (carriers) => carriers.all.items);
export const selectAllIncluded = createSelector(carriersState, (carriers) => carriers.all.included);
export const selectCarriersPagination = createSelector(carriersState, (carriers) => carriers.pagination);
export const selectCarriersLoading = createSelector(carriersState, (carriers) => carriers.loading);
